export default {
    path: '/tpp',
    name: 'tpp.index',
    component: () => import('./views/Index.vue'),
    meta: {
        label: 'TPP',
        icon: 'fal fa-globe fa-fw',
        permission: 'manage-tpp',
        auth: true,
        module: 'metatech/tpp',
    },
    children: [
        {
            path: 'servers/:serverId',
            name: 'tpp.server.show',
            component: () => import('./views/server/Show.vue'),
            meta: {
                label: 'Server',
                permission: 'manage-tpp',
            },
            children: [
                {
                    path: 'domains',
                    name: 'tpp.server.domains.index',
                    component: () => import('./views/server/domain/Index.vue'),
                    meta: {
                        label: 'Domains',
                        icon: 'fal fa-globe fa-fw',
                        permission: 'manage-tpp',
                    },
                    children: [
                        {
                            path: ':domainId/edit',
                            name: 'tpp.server.domains.edit',
                            component: () => import('./views/server/domain/Index.vue'),
                            meta: {
                                label: 'Edit Domain',
                                permission: 'manage-tpp',
                            },
                        },
                        {
                            path: ':domainId/details',
                            name: 'tpp.server.domains.details',
                            component: () => import('./views/server/domain/Index.vue'),
                            meta: {
                                label: 'TPP Domain Details',
                                permission: 'manage-tpp',
                            },
                        },
                        {
                            path: ':domainId/nameservers',
                            name: 'tpp.server.domains.nameservers',
                            component: () => import('./views/server/domain/Index.vue'),
                            meta: {
                                label: 'TPP Domain Nameservers',
                                permission: 'manage-tpp',
                            },
                        },
                        {
                            path: ':domainId/contacts',
                            name: 'tpp.server.domains.contacts',
                            component: () => import('./views/server/domain/Index.vue'),
                            meta: {
                                label: 'TPP Domain Contacts',
                                permission: 'manage-tpp',
                            },
                        },
                    ],
                },
            ],
        },
    ],
}
